export default [
  {
    id: `material`,
    title: `Качество материала`,
    content: {
      description: `<h3>Чехол для iPhone 4/4S</h3><p>Телефон - это  вещь, которая всегда рядом. Чехол для iphone поможет защитить и украсить его. Ну а чехол для iphone с фото - это не просто стильный аксессуар, но и прекрасный фотоподарок. Вы можете приобрести чехол для iPhone 4/4S c фото или рисунком, создав свой дизайн у нас на сайте. У вас получится отличный фотосувенир!</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `<p>Печать УФ красками. Никаких накладок или наклеек. Рисунок печатается прямо на чехол. Яркая и стойкая печать возможна благодаря инновационой технологии печати.</p>`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
